import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { styled } from "@mui/system";
import { colors } from "../config/colors";
import { Typography } from "@mui/material";
import { SessionInfoLogo } from "../assets/icons";
import {
  DISPLAY_FLEX,
  FLEX_ALIGN_CENTER,
  FLEX_DIRECTION_COLUMN,
  MAX_WIDTH,
  BORDER_PRIMARY,
} from "../config/styles";

export const DELETE_ITEM_TYPES = {
  IMAGE: "image",
  SPECIFICATION: "specification",
  VARIANT: "variant",
  OVERRIDE: "override",
  CATEGORY: "category",
};

const DeleteProductStyled = styled(Modal)(({ theme }) => ({
  "& .modal-content": {
    maxWidth: "400px",
    margin: "auto",
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
  },
  "& .modal-header": {
    border: "none",
  },
  "& .modal-title": {
    ...theme.typography.body2,
    color: colors.custom,
    textAlign: "center",
    fontWeight: "bold",
  },
  "& .modal-body": {
    alignItems: FLEX_ALIGN_CENTER,
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    paddingBottom: "0",
    gap: "1rem",
  },
  "& .modal-footer": {
    display: "flex",
    justifyContent: "center",
    border: "none",
    width: MAX_WIDTH,
    padding: "1rem",
  },
  "& .session-expired-text": {
    ...theme.typography.subtitle1,
    color: colors.grayLight,
    marginBottom: "1rem",
  },
  "& .create-button": {
    ...theme.typography.body1,
    color: theme.palette.secondary.contrastText,
    backgroundColor: colors.warning,
    width: "45%",
    border: "none",
    "&:hover": {
      backgroundColor: colors.warning,
    },
  },
  "& .edit-button": {
    ...theme.typography.body1,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.secondary.contrastText,
    border: BORDER_PRIMARY,
    width: "45%",
    "&:hover": {
      backgroundColor: colors.grayLight,
    },
  },
}));

export const DeleteProductItem = ({
  show,
  onHide,
  description,
  type,
  onDone,
}) => {
  return (
    <DeleteProductStyled show={show} onHide={onHide} centered size="sm">
      <Modal.Header closeButton />
      <Modal.Body>
        <SessionInfoLogo />
        <Modal.Title className="modal-title">{`Delete ${type}?`}</Modal.Title>
        <Typography className="session-expired-text">
          {`Are you sure you want to delete ${description}?`}
        </Typography>
      </Modal.Body>
      <Modal.Footer>
        <Button className="edit-button" onClick={onHide}>
          Cancel
        </Button>
        <Button className="create-button" onClick={onDone}>
          {`Delete ${type}`}
        </Button>
      </Modal.Footer>
    </DeleteProductStyled>
  );
};
DeleteProductItem.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  description: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(DELETE_ITEM_TYPES)).isRequired,
  onDone: PropTypes.func.isRequired,
};
